import swiper from './modules/swiper.mjs'
import wow from './modules/wow.mjs'
import counter from './modules/counter.mjs'
import map from './modules/map.mjs'
import {dropdown} from './modules/dropdown.mjs'

let bredi = {
  init: () => {
    swiper()
    wow()

    let rellax = new Rellax('.rellax')
  },



  navbar: {
    toggleSticky: () => {
      let scrollY = window.scrollY
      const navbar = document.querySelector('.navbar')

      if (scrollY > 50) {
        navbar.classList.add('sticky')
      }
      else {
        navbar.classList.remove('sticky')
      }
    },
  },



  footer: {
    FAB: {
      closeBalloon: () => {
        const balloon = document.querySelector('.fab-wrapper .--balloon')

        balloon.style.display = 'none'
      }
    }
  }
}



window.addEventListener('DOMContentLoaded', function () {
  bredi.navbar.toggleSticky()
  bredi.init()
})


window.addEventListener('scroll', function () {
  bredi.navbar.toggleSticky()
})



document.addEventListener('click', e => {
  if (e.target.matches('.js--nav-menu-open')) {
    dropdown.open('.navbar-menu-box')
  }
  else if (e.target.matches('.js--nav-a11y-open')) {
    e.preventDefault()
    dropdown.open('.navbar-a11y-box')
  }
  else if (e.target.matches('.js--dropdown-target')) {
    dropdown.open(`#${e.target.id} .dropdown-box`)
  }
  else {
    dropdown.close()
  }

  if (e.target.matches('.js--close-fab-balloon')) {
    e.preventDefault()

    bredi.footer.FAB.closeBalloon()
  }
})



counter()

map()